import React from 'react'
import { useAlarmTypes } from 'src/hooks'
import ThresholdIndicator from './ThresholdIndicator'

export default function HighLimitIndicator(props) {
  const { HIGH_LIMIT_EXCEEDED: { icon, color } = {} } = useAlarmTypes()
  return (
    <ThresholdIndicator thresholdFieldName="highLimit" i18n="WEB_HIGH_LIMIT" icon={icon} color={color} {...props} />
  )
}
